<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') ||
                  '厂家名称/主要联系人/联系人手机/详细地址'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              v-if="allow('A')"
              @click="
                openEditPage({
                  pageType: 'add'
                })
              "
            >
              <b-icon-plus></b-icon-plus
              >{{ $l('INDEX.btn_add') || '新增' }} </b-button
            >
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_sup_name') || '厂家名称'">
              <el-input
                v-model.trim="form.supName"
                :placeholder="$l('form_label_pe_sup_name') || '请输入厂家名称'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_contact') || '主要联系人'">
              <el-input
                v-model.trim="form.contact"
                :placeholder="$l('form_label_pe_contact') || '请输入主要联系人'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_contact_mobile') || '联系人手机'"
            >
              <el-input
                v-model.trim="form.contactMobile"
                :placeholder="
                  $l('form_label_pe_contact_mobile') || '请输入联系人手机'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_sup_address') || '详细地址'">
              <el-input
                v-model.trim="form.supAddress"
                :placeholder="
                  $l('form_label_pe_sup_address') || '请输入详细地址'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-form-item :label="$l('form_label_modify_date') || '修改时间'"
            ><br />
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyBeginDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="
                  $l('form_label_pe_modify_date_begin') ||
                    '请选择修改时段（开始）'
                "
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyEndDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="
                  $l('form_label_pe_modify_date_end') ||
                    '请选择修改时段（结束）'
                "
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$l('form_label_pe_status') || '有效状态'">
            <el-checkbox-group v-model="form.custStatusList">
              <el-checkbox label="Y">{{
                this.$l('INDEX.form_label_valid') || '有效'
              }}</el-checkbox>
              <el-checkbox label="N">{{
                this.$l('INDEX.form_label_invalid') || '无效'
              }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reload">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const initForm = {
  keyword: '',
  custStatusList: ['Y']
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()

    let _this = this
    this.$eventBus.$on('supplierTableReload', function() {
      //------
      _this.query()
    })
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'master-supplierSet-detail',
        params: { ...params, pageType }
      })
    }
    //时间判断
    // selectDate(){
    // 	if (this.form.modifyBeginDate > this.form.modifyEndDate){
    // 		this.form.modifyBeginDate = this.form.modifyEndDate
    // 	}
    // },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
